export default {"src":"/_next/static/media/qr_code.f0e2434d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};